// @ts-nocheck
import { USER_ROLES } from "../../staticData/userRoles";
import { FRONTEND_CONFIG } from "./configs";

/**
 * function to return string according to role
 * @param {string} role
 * @returns {string} string
 */
export const getNewEventUrl = (role, userId) => {
  const url = "getNewEventsFor";
  switch (role) {
    case "admin":
      return url + "SuperAdmins";
    case "superAdmin":
      return url + "SuperAdmins";
    case "client":
      return url + "Clients" + (userId ? `/${userId}` : "");
    case USER_ROLES.COORDINATOR:
      return "getNewEventsOfCoordinator";
    default:
      return url;
  }
};

export const fetchPartialEventUrl = (role, userId) => {
  switch (role) {
    case USER_ROLES.ADMIN:
      return "getDraftAdminEvents";
    case USER_ROLES.SUPERADMIN:
      return "getDraftAdminEvents";
    case USER_ROLES.CLIENT:
      return "getDraftClientEvents";
  }
};

export const URLS = {
  COMMON: {
    HOME: "/",
    PRIVACY_POLICY: "/privacy-policy",
    TERMS_AND_CONDITIONS: "/terms-and-conditions",
    REQUEST_QUOTE: "/request-quote",
    LOGIN: "/login",
    NOTIFICATIONS: "/notifications",
    PROFILE: "/profile",
    CHAT: "/event/chat",
    CHAT_ADMIN: "/event/chat/admin"
  },

  ADMIN: {
    EVENT: {
      NEW_REQUESTS: "/event/new-requests",
      REQUEST_DETAILS: "/event/new-request/details",
      ALL_EVENTS: "/event/all-events",
      DETAILS: "/event/details",
      ESTIMATES: "/event/estimates",
      ESTIMATES_VIEW: "/event/estimates/view",
      SOW: "/event/sow",
      PO: "/event/po",
      FREELANCE_PO: "/event/freelancerPO"
    },
    POSITIONS: "/positions",
    CONTRACTORS: {
      LIST: "/contractors",
      ADD: "/contractors/add"
    },
    FIND_SOW: "/find-sow",
    REPORTS: "/reports",
    USERS: {
      ADMINS: "/users/admins",
      COORDINATORS: "/users/coordinators",
      CLIENTS: "/users/clients",
      DELETED: "/users/deleted" // SuperAdmin only
    }
  },

  CLIENT: {
    EVENT: {
      NEW_REQUESTS: "/event/new-requests",
      REQUEST_DETAILS: "/event/new-request/details",
      ALL_EVENTS: "/event/all-events",
      DETAILS: "/event/details",
      ESTIMATES: "/event/estimates",
      ESTIMATES_VIEW: "/event/estimates/view"
    },
    LOGS_OF_EVENT: "/logs-of-event"
  },

  CONTRACTOR: {
    OPPORTUNITIES: {
      NOT_RESPONDED: "/opportunities/not-responded",
      APPLIED: "/opportunities/applied"
    },
    SCHEDULE: "/schedule",
    RESOURCES: "/resources"
  },

  COORDINATOR: {
    EVENT: {
      ALL_EVENTS: "/event/all-events",
      DETAILS: "/event/details",
      SOW: "/event/sow",
      PO: "/event/po",
      FREELANCE_PO: "/event/freelancerPO"
    },
    USERS: {
      COORDINATORS: "/users/coordinators"
    },
    POSITIONS: "/positions",
    CONTRACTORS: {
      LIST: "/contractors",
      ADD: "/contractors/add"
    },
    FIND_SOW: "/find-sow"
  },

  SHAREABLE: {
    SOW: "/shareable/sow",
    PO: "/shareable/po",
    FREELANCE_PO: "/shareable/freelancerPO"
  },

  ERRORS: {
    NOT_FOUND: "*"
  }
};

/**
 * no navbar urls
 */
export const NO_NAVBAR_URLS = [
  "/live-events-rates",
  "/integrations-rates",
  "/sms-consent",
  "/consent/media-release-1099",
  "/consent/payment-terms-acknowledgement-1099",
  "/consent/text-communication-1099",
  "/consent/independent-contractor-aggreement-1099",
  "/consent/backstage-pass-1099",
  "/consent/electronic-execution-1099"
];

/**
 * contract consent routes
 */
export const WEB_CONTRACTOR_CONSENT = FRONTEND_CONFIG?.contractorConsentPages
  ? {
      ["1099"]: [
        {
          title: "Media Release",
          url: "/consent/media-release-1099"
        },
        {
          title: "Payment Terms Acknowledgement",
          url: "/consent/payment-terms-acknowledgement-1099"
        },
        {
          title: "Text Communication Consent",
          url: "/consent/text-communication-1099"
        },
        {
          title: "Independent Contractor Agreement",
          url: "/consent/independent-contractor-agreement-1099"
        },
        {
          title: "Backstage Pass",
          url: "/consent/backstage-pass-1099"
        },
        {
          title: "Electronic Execution",
          url: "/consent/electronic-execution-1099"
        }
      ],
      ["w2"]: [
        {
          title: "Media Release",
          url: "/consent/media-release-1099"
        },
        {
          title: "Payment Terms Acknowledgement",
          url: "/consent/payment-terms-acknowledgement-1099"
        },
        {
          title: "Text Communication Consent",
          url: "/consent/text-communication-1099"
        },
        {
          title: "Independent Contractor Agreement",
          url: "/consent/independent-contractor-agreement-1099"
        },
        {
          title: "Backstage Pass",
          url: "/consent/backstage-pass-1099"
        },
        {
          title: "Electronic Execution",
          url: "/consent/electronic-execution-1099"
        }
      ],
      ["V.C."]: [
        {
          title: "Media Release",
          url: "/consent/media-release-1099"
        },
        {
          title: "Payment Terms Acknowledgement",
          url: "/consent/payment-terms-acknowledgement-1099"
        },
        {
          title: "Text Communication Consent",
          url: "/consent/text-communication-1099"
        },
        {
          title: "Independent Contractor Agreement",
          url: "/consent/independent-contractor-aggreement-1099"
        },
        {
          title: "Backstage Pass",
          url: "/consent/backstage-pass-1099"
        },
        {
          title: "Electronic Execution",
          url: "/consent/electronic-execution-1099"
        }
      ]
    }
  : {
      ["1099"]: [
        {
          title: "Media Release",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Media+Release+1_21_26.pdf"
        },
        {
          title: "Payment Terms Acknowledgement",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Payment+Terms+Acknowledgement+1_21_26.pdf"
        },
        {
          title: "Text Communication Consent",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Text+Communication+Consent+Agreement+1_21_26.pdf"
        },
        {
          title: "Independent Contractor Agreement",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Idependent+Contractor+Agreement+(1).pdf"
        },
        {
          title: "Backstage Pass",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/SHOWPHAZE_+BACKSTAGE+PASS+Agreement.pdf"
        },
        {
          title: "Electronic Execution",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Electronic+Execution_+Click-to-Accept+for+Documents.pdf"
        }
      ],
      ["w2"]: [
        {
          title: "Media Release",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Media+Release+1_21_26.pdf"
        },
        {
          title: "Payment Terms Acknowledgement",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Payment+Terms+Acknowledgement+1_21_26.pdf"
        },
        {
          title: "Text Communication Consent",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Text+Communication+Consent+Agreement+1_21_26.pdf"
        },
        {
          title: "Independent Contractor Agreement",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Idependent+Contractor+Agreement+(1).pdf"
        },
        {
          title: "Backstage Pass",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/SHOWPHAZE_+BACKSTAGE+PASS+Agreement.pdf"
        },
        {
          title: "Electronic Execution",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Electronic+Execution_+Click-to-Accept+for+Documents.pdf"
        }
      ],
      ["V.C."]: [
        {
          title: "Media Release",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Media+Release+1_21_26.pdf"
        },
        {
          title: "Payment Terms Acknowledgement",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Payment+Terms+Acknowledgement+1_21_26.pdf"
        },
        {
          title: "Text Communication Consent",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Contractor+Text+Communication+Consent+Agreement+1_21_26.pdf"
        },
        {
          title: "Independent Contractor Agreement",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Idependent+Contractor+Agreement+(1).pdf"
        },
        {
          title: "Backstage Pass",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/SHOWPHAZE_+BACKSTAGE+PASS+Agreement.pdf"
        },
        {
          title: "Electronic Execution",
          url: "https://showphaze-assets.s3.us-east-2.amazonaws.com/contracts/Electronic+Execution_+Click-to-Accept+for+Documents.pdf"
        }
      ]
    };

export const CONTRACTOR_CONTRACT_UPDATED_AT = "Feb 26, 2026";